module.exports = __webpack_public_path__ + "img/1532458172.51db60b3.jpg";